<template>
  <div
    class="documents-actions"
    :class="{
      'documents-actions-red': record.expired && tableType === 'documents-acting-documents',
      'documents-actions-yellow': record.expireSoon && tableType === 'documents-acting-documents',
    }"
  >
    <m-create-edit-document
      :active="isShowEditDocumentModal"
      title="Редактировать документ"
      :current-document-id="record.documentTypeId"
      :is-edit="true"
      :document-id="record.documentId"
      :attached-files="record.files.items"
      :deadline="record.deadline.value"
      :comment="record.comment"
      @close="isShowEditDocumentModal = false"
    />

    <div class="documents-actions-buttons">
      <c-button
        v-if="record.comment !== null && record.comment.length > 0"
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: 'Комментарий',
          placement: 'top',
        }"
        class="documents-actions-comment"
        size="iconic"
        icon="comment"
        @click="isShowCommentModal = true"
      />
      <c-button
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: 'История изменений',
          placement: 'top',
        }"
        class="documents-actions-change-history"
        size="iconic"
        icon="change-history"
        @click="isShowHistoryChangesModal = true"
      />
      <c-button
        :id="`c-table-actions-menu-${recordId}`"
        tabindex="-1"
        class="documents-actions-menu documents-actions-menu-active"
        size="iconic"
        icon="menu"
      />
    </div>

    <b-modal
      id="documents-actions-comment-modal"
      v-model="isShowCommentModal"
      class="documents-actions-comment-modal"
      centered
      hide-footer
      hide-header
    >
      <div style="overflow: hidden; text-overflow: ellipsis">
        <svg
          class="documents-actions-comment-modal-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="isShowCommentModal = false"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        {{ record.comment }}
      </div>
    </b-modal>

    <b-modal
      id="documents-actions-history-changes-modal"
      v-model="isShowHistoryChangesModal"
      class="m-history-changes"
      centered
      hide-footer
      hide-header
      @show="onShowHistoryChangesModal"
    >
      <div>
        <svg
          class="m-history-changes-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="isShowHistoryChangesModal = false"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <div class="m-history-changes-title">История изменений</div>
        <div class="position-relative">
          <div id="history-changes-shadow-top" class="m-history-changes-content-shadow-top"></div>
          <div
            id="m-history-changes-content"
            :style="{ overflow: isLoadedHistoryChanges ? 'hidden' : '' }"
            class="m-history-changes-content"
            @scroll="setShadowHistoryChangesList"
          >
            <div class="m-history-changes-content-list">
              <div class="m-history-changes-content-list-loader">
                <font-awesome-icon v-if="isLoadedHistoryChanges" :icon="icon" spin />
              </div>
              <div
                v-for="(item, index) in documentHistoryChangesItems"
                :key="index"
                class="m-history-changes-content-list-item"
              >
                <template v-if="!isLoadedHistoryChanges && documentHistoryChangesItems.length > 0">
                  <div class="m-history-changes-content-list-item-time">{{ item.date }}</div>
                  <div class="m-history-changes-content-list-item-username">{{ item.name }}</div>
                  <div class="m-history-changes-content-list-item-status"> {{ item.status }}</div>
                </template>
              </div>
              <div
                v-if="!isLoadedHistoryChanges && documentHistoryChangesItems.length === 0"
                class="m-history-changes-content-list-empty"
              >
                Нет результатов
              </div>
            </div>
          </div>
          <div id="history-changes-shadow-bottom" class="m-history-changes-content-shadow-bottom"></div>
        </div>
      </div>
    </b-modal>

    <b-popover
      :id="`document-actions-menu-popover`"
      ref="popover"
      placement="bottomleft"
      triggers="click blur"
      :target="`c-table-actions-menu-${recordId}`"
    >
      <div class="documents-actions-menu-popover">
        <div
          v-if="userHavePermissionAddEditDocument() && tableType === 'documents-acting-documents'"
          class="documents-actions-menu-popover-item"
          @click="isShowEditDocumentModal = true"
        >
          <div class="documents-actions-menu-popover-item-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z"
                fill="#8E9CBB"
              />
            </svg>
          </div>
          <div class="documents-actions-menu-popover-item-label">Редактировать</div>
        </div>
        <div
          v-if="record.files.items !== null && record.files.items.length > 0"
          class="documents-actions-menu-popover-item"
          @click="downloadArchiveDocument"
        >
          <div class="documents-actions-menu-popover-icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.70711 6.29289C4.31658 5.90237 3.68342 5.90237 3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L4.70711 6.29289ZM7 10L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L7 10ZM10.7071 7.70711C11.0976 7.31658 11.0976 6.68342 10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L10.7071 7.70711ZM8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H8ZM14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10H14ZM2 10C2 9.44771 1.55228 9 1 9C0.447715 9 0 9.44771 0 10H2ZM3.29289 7.70711L6.29289 10.7071L7.70711 9.29289L4.70711 6.29289L3.29289 7.70711ZM7.70711 10.7071L10.7071 7.70711L9.29289 6.29289L6.29289 9.29289L7.70711 10.7071ZM8 10V1H6V10H8ZM12 10V12H14V10H12ZM12 12H2V14H12V12ZM2 12V10H0V12H2ZM2 12H2H0C0 13.1046 0.895431 14 2 14V12ZM12 12V14C13.1046 14 14 13.1046 14 12H12Z"
                fill="#8E9CBB"
              />
            </svg>
          </div>
          <div class="documents-actions-menu-popover-item-label">Скачать</div>
        </div>
        <div
          v-if="userHavePermissionMoveDocumentInArchive() && (tableType === 'documents-acting-documents' || tableType === 'documents-archive')"
          class="documents-actions-menu-popover-item"
          @click="changeArchiveStatusSingle"
        >
          <div class="documents-actions-menu-popover-item-icon">
            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 5H0V6H1V5ZM16 5V6H17V5H16ZM2 5V4H1V5H2ZM15 5H16V4H15V5ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9V7ZM10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7V9ZM14.5003 0H2.4997V2H14.5003V0ZM2.4997 0C1.12273 0 0 1.11598 0 2.49575H2C2 2.22552 2.22232 2 2.4997 2V0ZM0 2.49575V5H2V2.49575H0ZM17 5V2.49575H15V5H17ZM17 2.49575C17 1.11598 15.8773 0 14.5003 0V2C14.7777 2 15 2.22552 15 2.49575H17ZM1 6H16V4H1V6ZM13.4997 13H3.50031V15H13.4997V13ZM3.50031 13C3.22221 13 3 12.7741 3 12.5043H1C1 13.8844 2.12339 15 3.50031 15V13ZM3 12.5043V5H1V12.5043H3ZM14 5V12.5043H16V5H14ZM14 12.5043C14 12.7741 13.7778 13 13.4997 13V15C14.8766 15 16 13.8844 16 12.5043H14ZM2 6H15V4H2V6ZM7 9H10V7H7V9Z"
                fill="#8E9CBB"
              />
            </svg>
          </div>
          <div v-if="tableType === 'documents-acting-documents'" class="documents-actions-menu-popover-item-label">Переместить в архив</div>
          <div v-if="tableType === 'documents-archive'" class="documents-actions-menu-popover-item-label">Восстановить из архива</div>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapGetters } from "vuex";
import moment from "moment";
import Button from "@/components/controls2/Button";
import CreateEditDocumentModal from "@/pages/personal-employee/additions/modals/documents-create-edit-document-modal";

export default {
  name: "documents-actions",

  components: {
    "c-button": Button,
    "m-create-edit-document": CreateEditDocumentModal,
    FontAwesomeIcon,
  },

  props: ["record", "recordId", "tableType"],

  data() {
    return {
      isShowCommentModal: false,
      isLoadedHistoryChanges: false,
      isShowHistoryChangesModal: false,
      icon: faSpinner,
      isShowEditDocumentModal: false,
      documentHistoryChangesItems: [],
    };
  },

  computed: {
    ...mapGetters(["getUserPermissions"]),
  },

  mounted() {
    setTimeout(() => {
      this.setShadowHistoryChangesList();
    }, 500);
  },

  methods: {
    userHavePermissionAddEditDocument() {
      return this.getUserPermissions.includes("updateWorkerDocuments");
    },

    userHavePermissionMoveDocumentInArchive() {
      return (
        this.getUserPermissions.includes("updateWorkerDocuments") ||
        this.getUserPermissions.includes("viewWorkerDocuments")
      );
    },

    setShadowHistoryChangesList() {
      const shadowBottomElement = document.getElementById("history-changes-shadow-bottom");
      const shadowTopElement = document.getElementById("history-changes-shadow-top");
      const scrollElement = document.getElementById("m-history-changes-content");
      if (scrollElement !== null) {
        // if container scrollable
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          // top shadow handler
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-history-changes-content-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-history-changes-content-shadow-top-active");
          }
          // bottom shadow handler
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("m-history-changes-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-history-changes-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-history-changes-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-history-changes-content-shadow-bottom-active");
        }
      }
    },

    changeArchiveStatusSingle() {
      this.$emit("changeArchiveStatusSingle", this.record.documentId);
      this.$refs.popover.$emit("close");
    },

    onShowHistoryChangesModal() {
      this.isLoadedHistoryChanges = true;
      this.documentHistoryChangesItems = [];
      this.$store.dispatch("personalEmployee/getDocumentHistory", this.record.documentId).then((res) => {
        if (res.name === "Exception" && res.code === 0) {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: "Произошла ошибка. Попробуйте позже.",
            },
          });
          this.isLoadedHistoryChanges = false;

          return false;
        }
        this.documentHistoryChangesItems = res.response;
        setTimeout(() => {
          this.isLoadedHistoryChanges = false;
        }, 250);
      });
    },

    downloadArchiveDocument() {
      this.$store.dispatch("personalEmployee/getLinkOnDocumentWorkerDownload", this.record.documentId).then((res) => {
        const urlToArchive = window.location.origin + res.response;
        const link = document.createElement("a");
        link.download = `Документ_${moment().format("DD_MM_YYYY")}.zip`;
        link.href = urlToArchive;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.documents-actions {
  width: 100%;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 700px) {
    justify-content: flex-start;
  }

  &-buttons {
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px;

    @media screen and (max-width: 700px) {
      justify-content: flex-start;
    }
  }

  &-red {
    background: #ffe6f2;

    @media screen and (max-width: 700px) {
      background: #ffffff;
    }
  }

  &-yellow {
    background: #fdffb3;

    @media screen and (max-width: 700px) {
      background: #ffffff;
    }
  }

  &-comment {
    ::v-deep svg {
      width: 15px !important;
      height: 16px !important;
    }
  }

  &-comment-modal {
    position: relative;
    overflow-wrap: normal;
    word-break: break-all;

    &-close {
      cursor: pointer;
      position: absolute;
      top: 13px;
      right: 12px;
    }
  }

  &-change-history {
    margin-left: 10px;

    @media screen and (max-width: 700px) {
      margin-left: 18px;
    }
  }

  &-menu {
    margin-left: 10px;

    @media screen and (max-width: 700px) {
      margin-left: 18px;
    }
  }

  &-download {
    margin-left: 10px;

    @media screen and (max-width: 700px) {
      margin-left: 18px;
    }
  }

  &-menu {
    display: none;

    &-active {
      display: block;
    }
  }

  &-menu-popover {
    border-radius: 6px;

    &-item {
      display: flex;
      align-items: center;
      padding: 6px 23px;
      cursor: pointer;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }

      &-icon {
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: -2px;
        margin-left: -4px;
      }

      &-label {
        font-size: 15px;
        line-height: 17px;
        margin-left: 10px;
        overflow: hidden;
        &-bold {
          font-weight: 500;
        }
      }
    }
  }
}

.m-history-changes {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 13px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
  }

  &-content {
    position: relative;
    margin-top: 19px;
    max-height: 377px;
    width: calc(100% + 10px);
    overflow-y: auto;

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 78px);
    }

    &-shadow-top {
      content: "";
      position: absolute;
      background: transparent;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 10;
      height: 30px;
      width: calc(100% + 20px);
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
      }
    }

    &-shadow-bottom {
      content: "";
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
    }

    &-list {
      display: flex;
      flex-direction: column;
      width: calc(100% - 10px);

      &-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-top: 1px solid #dfe4ef;
        padding: 9px;

        &:last-child {
          border-bottom: 1px solid #dfe4ef;
        }

        &-time {
          min-width: 70px;
          color: #8e9cbb;
        }

        &-username {
          min-width: 180px;
          margin-left: 8px;
        }

        &-status {
          min-width: 70px;
          margin-left: 8px;
        }
      }

      &-loader {
        margin: 0 auto;
        font-size: 32px;
        color: $pink;
      }
    }
  }
}
</style>
